const restaurant = {
  restaurant: "Restaurant", // translated
  restaurants: "Restaurants", // translated
  category: "Kategorie", // translated
  score: "Punktzahl", // translated
  priceQuartile: "Preisquartil", // translated
  scoreLowestFirst: "Punktzahl (niedrigste zuerst)", // translated
  scoreHighestFirst: "Punktzahl (höchste zuerst)", // translated
  priceLowestFirst: "Preis: niedrigster zuerst)", // translated
  priceHighestFirst: "Preis: höchster zuerst)", // translated
  allPrices: "Alle Preise", // translated
  reserve: "Reservieren", // translated
  dining: "Essen", // translated
};

export default restaurant;
